import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import T from 'prop-types';

import Select from 'react-select';

const styles = {
  control: (base, state) => ({
    ...base,
    border: `1px solid #CED4DA`,
    boxShadow: 'none',
    '&:hover': {
      border: `1px solid #CED4DA`,
    },
    fontFamily: "Montserrat",
    fontWeight: 400,
    borderRadius: 0,
    borderLeft: 'none',
    flexWrap: 'nowrap',
    height: '2.25rem',
    maxWidth: '6rem',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: 'none',
    '&:hover': { backgroundColor: 'none' },
    color: 'black',
    fontWeight: 300,
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'capitalize',
  }),
  valueContainer: (base, state) => ({
    ...base,
    textOverflow: "ellipsis",
    width: '3.5rem',
    whiteSpace: "nowrap",
    overflow: "hidden",
    marginRight: '4px',
    marginLeft: '2px',
    paddingLeft: '2px',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    paddingRight: '2px',
  }),
  menu: (base, state) => ({
    ...base,
    maxWidth: '90%',
    textOverflow: "ellipsis",
  }),
  menuList: (base, state) => ({
    ...base,
    maxHeight: '200px',
    overflowY: 'scroll',
  }),
};

const InputChoice = (props) => {
  const [options, setOptions] = useState(props.choices);
  const [choice, setChoice] = useState(options[0]);

  useEffect(() => {
    if (props.current_choice.value) {
      setChoice(options.find(option => option.value === props.current_choice.value));

      const inputFieldBox = document.querySelector('#input-choice__input-container .input-choice__input-field');
      inputFieldBox.innerHTML = `
      <input type="text" name="query[${choice.value}]" />
        `;
      document.querySelector('#input-choice__input-container .input-choice__input-field input').value = props.current_choice.text
    }
  }, []);

  useEffect(() => {
    const inputFieldBox = document.querySelector('#input-choice__input-container .input-choice__input-field');

    const prevInput = document.querySelector('#input-choice__input-container .input-choice__input-field input');
    const prevInputValue = prevInput ? prevInput.value : '';

    inputFieldBox.innerHTML = `
      <input type="text" name="query[${choice.value}]" />
    `;

    if (prevInput && props.current_choice.text) {
      document.querySelector('#input-choice__input-container .input-choice__input-field input').value = props.current_choice.text;
    } else {
      document.querySelector('#input-choice__input-container .input-choice__input-field input').value = prevInputValue;
    }
  }, [choice]);

  const onChange = selected => {
    setChoice(selected);
  };

  return (
    <>
      <div className='select-container__label'>Search by</div>
      <div className='select-container'>
        <div id='input-choice__input-container'>
          <svg width="32" height="32" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.75 14.75L11.3855 11.3795L14.75 14.75ZM13.25 6.875C13.25 8.56576 12.5784 10.1873 11.3828 11.3828C10.1873 12.5784 8.56576 13.25 6.875 13.25C5.18424 13.25 3.56274 12.5784 2.36719 11.3828C1.17165 10.1873 0.5 8.56576 0.5 6.875C0.5 5.18424 1.17165 3.56274 2.36719 2.36719C3.56274 1.17165 5.18424 0.5 6.875 0.5C8.56576 0.5 10.1873 1.17165 11.3828 2.36719C12.5784 3.56274 13.25 5.18424 13.25 6.875V6.875Z" stroke="#1F0F3C" strokeLinecap="round"/>
          </svg>
          <div className='input-choice__input-field'></div>
        </div>
        <Select
          className="custom-single-select"
          classNamePrefix='select'
          value={choice}
          isClearable={false}
          isSearchable={false}
          placeholder={null}
          options={options}
          styles={styles}
          onChange={onChange}
        />
      </div>
    </>
  )
}

InputChoice.propTypes = {
  current_choice: T.object,
  choices: T.arrayOf(T.object),
}

export default InputChoice;
